import React from 'react';

import ArticleCard from '../ArticleCard/ArticleCard';
import ArticleListing from '../ArticleListing/ArticleListing';
import Type from '../UI/Type/Type';
import * as styles from './ArticleLanding.module.scss';

const ArticleLanding = ({ nodes }) => {
  const latestPost = nodes?.slice(0, 1)[ 0 ];
  const recentPosts = nodes?.slice(1, 10);
  const olderPosts = nodes?.slice(10);

  return !nodes.length ? null : (
    <div className={styles.container}>
      <div className={styles.top}>
        <div className={styles.featured}>
          <ArticleCard
            {...latestPost.article}
            className={styles.card}
            title={latestPost.title}
            author={latestPost.author}
            categories={latestPost.categories}
            uri={latestPost.uri}
            isPrimary
          />
        </div>

        <div className={styles.recentPosts}>
          <Type.H3 as="h2">Recent stories</Type.H3>
          {!!recentPosts.length && (
            <ArticleListing nodes={recentPosts} isList />
          )}
        </div>
      </div>

      {!!olderPosts.length && (
        <ArticleListing nodes={olderPosts} chunkSize={8} isChunked />
      )}
    </div>
  );
};

export default ArticleLanding;
